import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'
const caracter = Yup.string().required(mensagemPadrao)

export const schemaNovaMatricula = Yup.object().shape({
  turmaId: caracter
})
